/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Test_PrintInputs */

const vi_print_admin_test_print = /** @type {(inputs: Print_Admin_Test_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In thử`)
};

/**

* @param {Print_Admin_Test_PrintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_test_print = /** @type {((inputs?: Print_Admin_Test_PrintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Test_PrintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_test_print(inputs)
});